module.exports = __webpack_public_path__ + "static/media/dicom.4b70db77.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgicons/dicom.svg
// module id = 186
// module chunks = 0